export var ThemeMode;
(function (ThemeMode) {
    ThemeMode["dark"] = "dark";
    ThemeMode["light"] = "light";
})(ThemeMode || (ThemeMode = {}));
//# sourceMappingURL=theme.js.map